
import { Vue, Component, Watch } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { getExtData, handleSubmitFilter, uploadFile } from '@/api/seTel'
import { CommonModule } from '@/store/module/common'
import { ItaskOrderEditData } from '@/@types/global'
import { getCountryList } from '@/api/tools'

@Component({
  name: 'AddForm'
})
export default class AddForm extends Vue {
  // 表单校验
  fileList: any[] = []
  submitData: ItaskOrderEditData = {
    UserDBCode: '',
    CountryCode: '',
    NumberTypeID: 0,
    OriginFilePath: '',
    SourceType: 'file',
    PhoneStart: undefined,
    Quantity: undefined,
    Remarks: '',
    code: '',
    okCount: 0,
    fileCount: 0
  }
  initDialog() {
    // 初始化数据
    this.submitData = {
      UserDBCode: '',
      CountryCode: '',
      NumberTypeID: 0,
      OriginFilePath: '',
      SourceType: 'file',
      PhoneStart: undefined,
      Quantity: undefined,
      Remarks: '',
      code: '',
      okCount: 0,
      fileCount: 0
    }
    this.fileList = []
    // const uploadRef = this.$refs.uploadRef as Upload
    // uploadRef.clearFiles()
    this.inputFields = []
    this.selectFields = []
  }

  inputFields: any[] = []
  selectFields: any[] = []
  get extFields() {
    const temp = CommonModule.currentExtField
    this.inputFields = []
    this.selectFields = []
    if (typeof temp === 'object') {
      const arr = temp.ext
      arr?.forEach(item => {
        if (item.type === 'input') {
          this.$set(this.submitData, item.name, '')
          this.inputFields.push(item)
        } else if (item.type === 'select') {
          this.formatSelectItem(item)
        }
      })
    }
    return CommonModule.currentExtField
  }

  get extInfo() {
    return CommonModule.currentInfo
  }

  formatSelectItem(item: any) {
    const temp: any[] = []
    this.$set(this.submitData, item.name, '')
    if (item.url) {
      // 如果是返回url，需要请求对应接口
      // 接口已加统一前缀，因此需要手动将多余的前缀移除
      getExtData(item.url.replace('/api', '')).then((res: any) => {
        const result = res.data
        result.forEach((sub: any) => {
          temp.push({
            label: sub.Code,
            value: `${sub.TaskGuid}&${sub.UserDBCode}&${sub.OkQuantity}`
          })
        })
      })
    } else if (item.data) {
      // 如果是返回data,那么直接用data里面的参数
      item.data.forEach((sub: string) => {
        temp.push({
          label: sub.split(':')[1],
          value: sub.split(':')[0]
        })
      })
    } else if (item.dataRange) {
      // 如果是返回dateRange,那么需要切割处理
      const start = item.dataRange.split('-')[0]
      const end = item.dataRange.split('-')[1]
      for (let i = start; i <= end; i++) {
        temp.push({
          label: +i,
          value: +i
        })
      }
    }
    this.selectFields.push({
      ...item,
      items: temp
    })
  }

  get showSourceType() {
    return !(this.extFields?.sourceType !== undefined && this.extFields.sourceType === false)
  }

  handleShow(item: any) {
    return item.name === 'taskCode' && this.submitData[item.name] !== ''
  }

  calOkNum(item: any) {
    const key = this.submitData[item.name]
    let temp = ''
    if (item.items?.length > 0) {
      item.items.forEach((sub: any) => {
        if (sub.value === key) {
          temp = sub.value.split('&').pop()
        }
      })
    }
    this.submitData.okCount = +temp
    return '号码有效数：' + temp
  }

  @Watch('submitData.SourceType', { deep: true })
  handleTypeChange() {
    const formRef = this.$refs.formRef as Form
    formRef.clearValidate()
  }

  handleChange(file: File, fileList: any[]) {
    this.fileList = fileList.slice(-1)
  }
  handleBeforeUpload(file: File) {
    // 上传的文件校验
    const { name } = file

      if (!this.submitData.CountryCode) {
      this.$message.error('请先选择仓库！')
      return false
    } else if (!name.endsWith('.txt') && !name.endsWith('.csv')) {
      this.$message.error('请上传txt或csv格式文件')
      return false
    }
  }
  handleUpload(e: any) {
    // 自定义上传逻辑
    const { file } = e
    const formData = new FormData()
    formData.append('file', file)
      formData.append('countryCode', this.submitData.CountryCode)
    uploadFile(formData)
      .then((res: any) => {
        this.$message.success('上传成功')
        this.submitData.OriginFilePath = res.path
        this.submitData.fileCount = res.fileCount
        this.submitData.okCount = res.okCount
        const formRef = this.$refs.formRef as Form
        formRef.validateField('fileMd5')
      })
      .catch(err => {
        this.$message.error(err.msg)
        // const uploadRef = this.$refs.uploadRef as Upload
        // uploadRef.clearFiles()
      })
  }

  // 下拉框查询仓库接口
  filterCountrys(){

      if (CommonModule.currentCountrys && CommonModule.currentCountrys.length > 0) {
          return this.countryList.filter(function (cc) {
              if (CommonModule.currentCountrys.includes(cc.value)) {
                  return cc;
              }
          })
      } else {
          return this.countryList
      }
  }
  countryList = []
  tempCountryData = []
  isLoading = false
  isFirst = true
  handleInitSelect() {
    // 用于首次点击下拉框时初始化数据
    if (this.isFirst) {
      this.isFirst = false
      this.getCountryList()
    }
  }
  remoteMethod(query: any) {
    if (query) {
      const temp = []
      this.tempCountryData.forEach(item => {
        if (item.label.includes(query) ||('+'+item.areaCode).includes(query) ) {
          temp.push(item)
        }
      })
      this.countryList = temp
    } else {
      this.countryList = this.tempCountryData
    }
  }
  getCountryList() {
    this.isLoading = true
    getCountryList()
      .then((res: any) => {
        // 返回的格式必须是{label: '', value: ''}
        const list = res.list
        const temp: any[] = []
        list.forEach((item: any) => {
          temp.push({
            label: item.name,
            value: item.code,
            areaCode:item.areaCode
          })
        })
          
        this.tempCountryData = temp
        this.countryList = temp
      })
      .catch(err => {
        this.$message.error(err.msg)
      })
      .finally(() => {
        this.isLoading = false
      })
  }
  // 点选后重新校验表单
  handleSelect() {
    const formRef = this.$refs.formRef as Form
    formRef.validateField('code')
  }
  //检查是否选择国家
    handleChkCountry() {
        if (this.submitData.CountryCode == "") {
            this.$message.error("请选择地区！")
            event.stopPropagation();
            return false;
        }
    }
  // 预估费用计算
  get properCost() {
    let ammount = 0
    let price = CommonModule.currentInfo.Price / 1000
    if (this.submitData.SourceType === 'file') {
        ammount = +price * this.submitData.okCount
    } else if (this.submitData.SourceType === 'range') {
        ammount = +price * (this.submitData.Quantity || 0)
    } else {
      ammount = +price * this.submitData.okCount
    }
    return Number(String(ammount).replace(/^(.*\..{4}).*$/, '$1'))
  }
  // @Watch('submitData.okCount', { immediate: true, deep: true })
  // calcProperCost() {
  // if (this.submitData.SourceType === 'file') {
  // this.properCost = +CommonModule.currentInfo.Price * this.submitData.okCount
  // } else if (this.submitData.SourceType === 'range') {
  //   this.properCost = +CommonModule.currentInfo.Price * this.submitData.Quantity
  // }
  // }

  // 点击保存按钮
  handleSave() {
    const formRef = this.$refs.formRef as Form
    formRef.validate(valid => {
      if (valid) {
        let data: any = {}
        if (this.extFields && this.extFields.ext && this.extFields.ext[0].name === 'taskCode') {
            // 单独指定扩展字段为taskCode时提交的内容
            
          data = {
            NumberTypeID: CommonModule.currentSubMenuID as number,
            Remarks: this.submitData.Remarks,
            taskCode: this.submitData.taskCode.split('&')[0]
          }
          this.submitEnd(data)
        } else {
          data = this.submitData
          if (data.SourceType === 'file') {
            if (data.okCount < this.extInfo.MinQuantity || data.okCount === 0) {
              this.$message.error('提交数量小于最低数量！')
            } else if (data.okCount > this.extInfo.MaxQuantity) {
              this.$message.error('提交数量大于最高数量！')
            } else {
              this.submitEnd(data)
            }
          } else if (data.SourceType === 'range') {
            if (data.Quantity < this.extInfo.MinQuantity || data.Quantity === 0 || !data.Quantity) {
              this.$message.error('提交数量小于最低数量！')
            } else if (data.Quantity > this.extInfo.MaxQuantity) {
              this.$message.error('提交数量大于最高数量！')
            } else {
              this.submitEnd(data)
            }
          } else {
            this.submitEnd(data)
          }
        }
      }
    })
  }
  submitEnd(data: any) {
    this.$confirm(`当前任务需消耗 ${this.properCost} ，是否继续？`, '确认操作', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
        .then(() => {
        Object.keys(data).forEach(item => {                
          if (item === 'SourceType') {
            // 如果是常规情况，即选择文件上传或号码范围
            if (data[item] === 'file') {
              delete data.PhoneStart
              delete data.Quantity
            } else {
              delete data.OriginFilePath
            }
          }
          if (!this.showSourceType) {
            // 如果是有额外字段
            delete data.PhoneStart
            delete data.Quantity
            delete data.OriginFilePath
            delete data.SourceType
          }
          if (item === 'fileCount' || item === 'okCount' || item === 'code') {
            delete data[item]
          } else if (item === 'CountryCode') {
           // data[item] = this.submitData.code
          } else if (item === 'NumberTypeID') {
            data[item] = CommonModule.currentSubMenuID as number
          } else if (!data[item] || data[item] === '') {
            delete data[item]
          }
        })
            
        handleSubmitFilter(data)
          .then(() => {
            this.$message.success('添加成功')
            this.$emit('addSuccess')
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      })
      .catch(() => {
        console.log('cancel')
      })
  }

  // 表单校验
  rule = {
    code: [{ required: true, trigger: 'blur', message: '请筛选地区' }],
    fileMd5: [{ required: true, trigger: 'change', validator: this.fileMd5Valid }],
    PhoneStart: [{ required: true, trigger: 'blur', validator: this.PhoneStartValid }],
    Quantity: [{ required: true, trigger: 'blur', validator: this.QuantityValid }]
  }
  fileMd5Valid(rule: any, value: string, cb: Function) {
    if (this.showSourceType) {
      if (this.submitData.SourceType === 'file') {
        if (!this.submitData.OriginFilePath) {
          return cb(new Error('请上传号码'))
        } else {
          return cb()
        }
      } else {
        return cb()
      }
    } else {
      return cb()
    }
  }
  PhoneStartValid(rule: any, value: string, cb: Function) {
    if (this.showSourceType) {
      if (this.submitData.SourceType === 'range') {
        if (!value) {
          return cb(new Error('请输入起始数字'))
        } else {
          return cb()
        }
      } else {
        return cb()
      }
    } else {
      return cb()
    }
  }
  QuantityValid(rule: any, value: number, cb: Function) {
    if (this.showSourceType) {
      if (this.submitData.SourceType === 'range') {
        if (value >= 1 && value <= 1000000) {
          return cb()
        } else {
          return cb(new Error('请输入1-1000000范围内数字'))
        }
      } else {
        return cb()
      }
    } else {
      return cb()
    }
  }
}
